import {
  getUserAddress
} from '../../modules/PersonalInformation/personalInformation.selectors';
import {createSelector} from 'reselect';

export const getWithholdingStateData = (state) =>
  state.StateWithholding.withholdingData;
export const getMandatoryWithholdingStates = createSelector(
  getWithholdingStateData,
  (stateData) => {
    return stateData
      ?.filter(({ mandatory }) => !!mandatory)
      ?.map(({ stateCode }) => stateCode);
  }
);
export const getWithholdingStateLookup = (state) =>
  state.StateWithholding.stateLookup;
export const getUserStateWithholdingRules = createSelector(
  getUserAddress,
  getWithholdingStateLookup,
  (userAddress, stateLookup) => {
    const stateRules = stateLookup?.[userAddress?.state ?? ''] || {};
    return {
      ...stateRules,
    };
  }
);
